import { useDispatch, useSelector } from "react-redux";
import {
  updateBookingListData,
  updateBookingDetails,
  updateInvoiceDetails,
  updateShowMainBookingDetailsDrawer,
  updateActiveTab,
  updateDisplayCheckInDrawer,
  updateShowGrcDrawer,
  updateShowFolioDrawer,
  updateShowRefundPaymentDrawer,
  postPaymentAndUpdateInvoiceDetails,
  updateShowAttachToPartyDrawer,
  updateAttachPartyString,
  updateAttachPartyValue,
  updateDisplayCheckOutDrawer,
  updateDisplayCheckOutDrawerAction,
  updateShowApplyDiscountDrawer,
  updateMobileBookingDetailsId,
  updateDisplayDeletePartyModal,
  updatePaymentDetails,
  updateDisplayCancelBookingModal,
  resetBookingDetails,
  deleteBookingDetails,
  updateDisplayDeleteBookingModal,
  updateDisplayUndoCompletedBookingModal,
  updateDisplayUndoNoShowBookingModal,
  updateDetailedPriceBreakup
} from "../../reducer/bookingReducer";

import {bookingSlice as updateBookingSlice} from "../../reducer/bookingReducer";
import {walkinSlice as createBookingSlice} from "../../reducer/walkinReducer"

import { updateBookingListData as updateReservationCalendarBookingListData } from "../../reducer/bookingReservationReducer";
import {
  bookingDetailsAddOnsCalculationV2,
  bookingPriceCalculation,
  buildDetailedPriceBreakup,
  mealPlanChangeCalculation,
  findTaxPercentage,
  buildPriceBreakup,
  generateDetailedPriceBreakupForEditBookings
} from "../../utils/bookingHelper";

import { updateinvoice, postPayment } from "../../services/invoice";

import { message } from "antd";
import { updatePayment, deletePayment } from "../../reducer/paymentReducer";
import { updateActiveFooter } from "../../reducer/appHeaderReducer";
import { useEffect } from "react";
import { id } from "date-fns/locale";
import { FaPercentage } from "react-icons/fa";

import moment from "moment";

const useAllBookingFunction = (setLoading) => {
  const dispatch = useDispatch();

  const { hotelDetails } = useSelector((store) => store.login);
  const {taxResponse} = useSelector((store) => store.tax);
  const loginStore = useSelector((store) => store.login);
  const { bookingResponse: bookingReservationResponse } = useSelector(
    (store) => store.bookingReservation
  );
  const roomsStore = useSelector((store) => store.rooms);

  const {
    showMainBookingDetailsDrawer,
    bookingDetails,
    invoiceDetails,
    paymentDetails,
    detailedPriceBreakup,
    roomPriceStructure,
    response: bookingResponse,
    nightsCount,
  } = useSelector((store) => store.booking);
  const updateBookingStore = useSelector((store) => store.booking);
  const createBookingStore = useSelector((store) => store.walkin);

  const { currentNightAuditDate, currentNightAuditDateError } = useSelector(
    (store) => store.appHeader
  );

  const { response: roomResponse } = useSelector((store) => store.rooms);

  const roomTypes = hotelDetails?.roomTypes ? hotelDetails?.roomTypes : [];
  const mandatoryCheckInDetailsDisabled =
    hotelDetails?.mandatoryCheckInDetailsDisabled;

  const bookingId = showMainBookingDetailsDrawer?.bookingId;
  const bookingType = showMainBookingDetailsDrawer?.bookingType;

  const handleCheckIn = async () => {
    // setLoading(true);

    const arrival = Boolean(bookingDetails?.arrival)
      ? bookingDetails?.arrival
      : "";
    const destination = Boolean(bookingDetails?.destination)
      ? bookingDetails?.destination
      : "";
    const purposeOfVisit = Boolean(bookingDetails?.purposeOfVisit)
      ? bookingDetails?.purposeOfVisit
      : "";

    let checkInDate = moment(bookingDetails?.checkIn)?.format("YYYY-MM-DD");
    const daysDifference = moment(checkInDate)?.diff(
      currentNightAuditDate,
      "days"
    );

    

    if (
      (Boolean(arrival) && Boolean(destination) && Boolean(purposeOfVisit)) ||
      (Boolean(mandatoryCheckInDetailsDisabled) &&
        mandatoryCheckInDetailsDisabled === true)
    ) {
      const updatedData = JSON.parse(JSON.stringify(bookingDetails));

      updatedData.status = "checkedIn";

      const data = await dispatch(updateBookingDetails(updatedData));

      const bookings = bookingReservationResponse?.bookings;

      if (!Boolean(data.error)) {
        let updatedBookingDetails = bookings?.map((Obj) =>
          Obj?.id === data?.payload?.id ? data?.payload : Obj
        );

        const newResponse = JSON.parse(
          JSON.stringify(bookingReservationResponse)
        );

        newResponse.bookings = updatedBookingDetails;

        await dispatch(updateReservationCalendarBookingListData(newResponse));

        dispatch(
          updateShowMainBookingDetailsDrawer({
            visible: false,
            bookingId: "",
            bookingType: "",
          })
        );
        dispatch(updateMobileBookingDetailsId(""));

        dispatch(updateActiveTab("ongoing"));
        dispatch(updateActiveFooter("Bookings"));

        setLoading(false);
        message.success("Successfully Checked In");
      } else {
        message.error(data.payload);
        setLoading(false);
      }
    } else {
      dispatch(updateDisplayCheckInDrawer());
      setLoading(false);
    }
  };

  const handleCheckOut = async () => {
    setLoading(true);
    const updatedData = JSON.parse(JSON.stringify(bookingDetails));

    updatedData.status = "completed";

    const bookings = bookingReservationResponse?.bookings;

    const data = await dispatch(updateBookingDetails(updatedData));

    if (Boolean(data.payload)) {
      let updatedBookingDetails = bookings?.map((Obj) =>
        Obj?.id === data?.payload?.id ? data?.payload : Obj
      );

      const newResponse = JSON.parse(
        JSON.stringify(bookingReservationResponse)
      );

      newResponse.bookings = updatedBookingDetails;

      await dispatch(updateReservationCalendarBookingListData(newResponse));

      dispatch(updateActiveTab("completed"));

      dispatch(updateMobileBookingDetailsId(""));

      message.success("Successfully Checked Out");
      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );
    } else {
      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );
      message.error("Something went wrong");
    }

    dispatch(updateActiveFooter("Bookings"));
    setLoading(false);
  };

  const handleUndoCheckIn = async () => {
    setLoading(true);

    const updatedData = JSON.parse(JSON.stringify(bookingDetails));

    updatedData.status = "confirmed";

    const data = await dispatch(updateBookingDetails(updatedData));

    if (!data?.payload?.id) {
      setLoading(false);
      message.info(data?.payload);
      dispatch(updateDisplayUndoNoShowBookingModal(false));
      return;
    }

    const bookings = bookingReservationResponse?.bookings;

    if (data.payload) {
      let updatedBookingDetails = bookings?.map((Obj) =>
        Obj?.id === data?.payload?.id ? data?.payload : Obj
      );

      const newResponse = JSON.parse(
        JSON.stringify(bookingReservationResponse)
      );

      newResponse.bookings = updatedBookingDetails;

      dispatch(updateReservationCalendarBookingListData(newResponse));

      dispatch(updateActiveTab("upcoming"));

      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );
      dispatch(updateDisplayUndoNoShowBookingModal(false));

      dispatch(updateMobileBookingDetailsId(""));

      message.success("Booking Successfully Updated");
    } else {
      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );
      dispatch(updateDisplayUndoNoShowBookingModal(false));

      message.error("Something went wrong");
    }

    dispatch(updateActiveFooter("Bookings"));
    setLoading(false);
  };

  const handleUndoCheckOut = async () => {
    setLoading(true);

    const updatedData = JSON.parse(JSON.stringify(bookingDetails));

    updatedData.status = "checkedIn";

    const data = await dispatch(updateBookingDetails(updatedData));

    if (!data?.payload?.id) {
      setLoading(false);
      dispatch(updateDisplayUndoCompletedBookingModal(false));
      message.info(data?.payload);
      return;
    }

    const bookings = bookingReservationResponse?.bookings;

    if (data.payload) {
      let updatedBookingDetails = bookings?.map((Obj) =>
        Obj?.id === data?.payload?.id ? data?.payload : Obj
      );

      const newResponse = JSON.parse(
        JSON.stringify(bookingReservationResponse)
      );

      newResponse.bookings = updatedBookingDetails;

      dispatch(updateReservationCalendarBookingListData(newResponse));

      dispatch(updateActiveTab("ongoing"));

      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );
      dispatch(updateDisplayUndoCompletedBookingModal(false));
      dispatch(updateMobileBookingDetailsId(""));

      message.success("Booking Successfully Updated");
    } else {
      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );
      message.error("Something went wrong");
    }

    dispatch(updateActiveFooter("Bookings"));
    setLoading(false);
  };

  const handleConfirmBooking = async () => {
    setLoading(true);

    const updatedData = JSON.parse(JSON.stringify(bookingDetails));

    updatedData.status = "confirmed";

    const data = await dispatch(updateBookingDetails(updatedData));

    if (!Boolean(data.error)) {
      dispatch(updateActiveTab("upcoming"));

      const bookings = bookingReservationResponse?.bookings;

      let updatedBookingDetails = bookings?.map((Obj) =>
        Obj?.id === data?.payload?.id ? data?.payload : Obj
      );

      const newResponse = JSON.parse(
        JSON.stringify(bookingReservationResponse)
      );

      newResponse.bookings = updatedBookingDetails;

      await dispatch(updateReservationCalendarBookingListData(newResponse));

      message.success("Booking Successfully Updated");

      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        })
      );

      dispatch(updateActiveFooter("Bookings"));
      dispatch(updateMobileBookingDetailsId(""));
    }

    setLoading(false);
  };

  const handleBookingToBeCanceld = async () => {
    setLoading(true);

    const updatedData = JSON.parse(JSON.stringify(bookingDetails));
    updatedData.status = "cancelled";

    await dispatch(updateBookingDetails(updatedData));

    dispatch(updateDisplayCancelBookingModal());

    const bookingList = bookingResponse?.bookings;

    const newBookingList = bookingList?.filter(
      (booking) => booking.id !== updatedData.id
    );

    const newResponse = { ...bookingResponse, bookings: newBookingList };

    dispatch(updateBookingListData(newResponse));
    dispatch(updateReservationCalendarBookingListData(newResponse));
    message.destroy();
    message.success("Booking Cancelled");

    dispatch(updateActiveFooter("Bookings"));
    dispatch(resetBookingDetails());
    setLoading(false);
  };

  const handleBookingToBeDeleted = async () => {
    setLoading(true);

    const payload = {
      hotelId: hotelDetails?.id,
      id: bookingDetails?.id,
    };

    const response = await dispatch(deleteBookingDetails(payload));

    if (response?.payload?.data) {
      const bookingList = bookingResponse?.bookings;

      const newBookingList = bookingList?.filter(
        (booking) => booking?.id !== bookingDetails?.id
      );

      const newResponse = { ...bookingResponse, bookings: newBookingList };

      dispatch(updateDisplayDeleteBookingModal());
      dispatch(updateBookingListData(newResponse));
      dispatch(updateReservationCalendarBookingListData(newResponse));

      message.destroy();
      message.success("The booking has been successfully deleted.");
      dispatch(updateActiveFooter("Bookings"));
      dispatch(resetBookingDetails());
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const handleBookingToBeMarkedNoShow = async () => {
    setLoading(true);
    const updatedData = JSON.parse(JSON.stringify(bookingDetails));

    updatedData.status = "noShow";

    await dispatch(updateBookingDetails(updatedData));
    const bookingList = bookingResponse?.bookings;

    const newBookingList = bookingList?.filter(
      (booking) => booking.id !== updatedData.id
    );
    const newResponse = { ...bookingResponse, bookings: newBookingList };
    dispatch(updateBookingListData(newResponse));
    dispatch(updateReservationCalendarBookingListData(newResponse));

    message.destroy();
    message.success("Booking marked as No Show");

    dispatch(updateActiveFooter("Bookings"));
    dispatch(resetBookingDetails());
    setLoading(false);
  };

  const handleFolio = () => {
    dispatch(
      updateShowMainBookingDetailsDrawer({
        visible: "false",
        bookingId: bookingId,
        bookingType: bookingType,
      })
    );
    dispatch(updateShowFolioDrawer(true));
  };

  const handleGrc = () => {
    dispatch(
      updateShowMainBookingDetailsDrawer({
        visible: "false",
        bookingId: bookingId,
        bookingType: bookingType,
      })
    );
    dispatch(updateShowGrcDrawer());
  };

  const refund = async (
    amount,
    setAmount,
    setReason,
    reason,
    paymentMode,
    methodToPartyId
  ) => {
    if (Boolean(amount)) {
      setLoading(true);

      let currentPaidValue = 0;
      let alreadyGivenRefund = 0;

      if (Array.isArray(paymentDetails)) {
        paymentDetails
          ?.map((Obj) => Obj?.amount)
          ?.filter((Obj) => Obj > 0)
          ?.map((Obj) => (currentPaidValue += Math.abs(Obj)));
      } else return false;

      if (Array.isArray(paymentDetails)) {
        paymentDetails
          ?.map((Obj) => Obj?.amount)
          ?.filter((Obj) => Obj < 0)
          ?.map((Obj) => (alreadyGivenRefund += Math.abs(Obj)));
      } else return false;

      const totalRefund = Math.abs(alreadyGivenRefund) + Math.abs(amount);

      if (totalRefund > currentPaidValue) {
        message.info("Refund should not be greater than paid value");
        setAmount("");
        setReason("");

        setLoading(false);
        return false;
      }

      let roomInvoiceId = Array.isArray(invoiceDetails)
        ? invoiceDetails
          ?.filter((Obj) => Obj?.invoiceType === "roomBill")
          ?.map((Obj) => Obj?.id)?.[0]
        : "";

      const paymentPayload = {
        amount: -amount,
        bookingId: showMainBookingDetailsDrawer?.bookingId,
        hotelId: hotelDetails?.id,
        method: paymentMode,
        remarks: reason,
        invoiceId: roomInvoiceId,
        paymentModePartyId: methodToPartyId[paymentMode],
      };

      const invoiceIdArray = Array.isArray(invoiceDetails)
        ? invoiceDetails?.map((Obj) => Obj?.id)?.filter((Obj) => Boolean(Obj))
        : [];

      const invoicePayload = {
        hotelId: hotelDetails?.id,
        invoiceIds: invoiceIdArray,
      };

      const payload = {
        paymentPayload: paymentPayload,
        invoicePayload: invoicePayload,
      };

      dispatch(postPaymentAndUpdateInvoiceDetails(payload));

      dispatch(updateShowRefundPaymentDrawer());
      setAmount("");
      setReason("");

      setLoading(false);
    } else {
      message.info("Please enter amount");
    }
  };

  const handleAttachToParty = async (
    response,
    balanceDue,
    partyResponse,
    attachPartyValue,
    setLoading
  ) => {
    if (!partyResponse || !partyResponse?.length) {
      message.info("Please select party first");
      return;
    }

    setLoading(true);

    let roomInvoice = invoiceDetails?.find(
      (Obj) => Obj?.invoiceType === "roomBill"
    );

    let partyId = partyResponse?.find(
      (Obj) => Obj?.displayName === attachPartyValue
    )?.id;

    let updatedInvoice = JSON.parse(JSON.stringify(roomInvoice));
    updatedInvoice.partyId = partyId;

    const payload = {
      id: updatedInvoice?.id,
      hotelId: hotelDetails?.id,
      body: updatedInvoice,
    };

    const oldPayment = paymentDetails?.find((Obj) => Obj?.method === "btc");

    if (Boolean(oldPayment)) {
      const paymentPayload = {
        hotelId: hotelDetails?.id,
        message: "Updated",
        paymentObj: {
          ...oldPayment,
          paymentModePartyId: partyId,
        },
      };

      const data = await updateinvoice(payload);

      if (Boolean(data?.id)) {
        const updatedData = invoiceDetails?.map((item) => {
          if (item.id === data.id) {
            return data;
          } else return item;
        });

        const oldUpdatedPayment = await dispatch(updatePayment(paymentPayload));

        const res = await dispatch(updateInvoiceDetails(updatedData));

        if (res?.type) {
          const newPaymentArray = response?.payments?.map((Obj) =>
            Obj?.id === oldUpdatedPayment?.payload?.id
              ? oldUpdatedPayment?.payload
              : Obj
          );

          const oldUpdatedPaymentDetails = paymentDetails?.map((Obj) =>
            Obj?.id === oldUpdatedPayment?.payload?.id
              ? oldUpdatedPayment?.payload
              : Obj
          );
          const newResponse = { ...response, payments: newPaymentArray };

          dispatch(updatePaymentDetails(oldUpdatedPaymentDetails));
          dispatch(updateBookingListData(newResponse));

          dispatch(updateDisplayCheckOutDrawerAction(false));
          dispatch(updateShowAttachToPartyDrawer(false));
          dispatch(updateAttachPartyString(""));
          dispatch(updateAttachPartyValue(""));
        } else message.error("Attach to Party failed");
      }
    } else {
      const paymentPayload = {
        amount: balanceDue,
        bookingId: bookingDetails?.id,
        hotelId: hotelDetails?.id,
        invoiceId: updatedInvoice?.id,
        method: "btc",
        paymentModePartyId: partyId,
      };

      const data = await updateinvoice(payload);

      if (Boolean(data?.id)) {
        const updatedData = invoiceDetails?.map((item) => {
          if (item.id === data.id) return data;
          else return item;
        });

        const newPayment = await postPayment(paymentPayload);
        const res = await dispatch(updateInvoiceDetails(updatedData));

        if (res?.type) {
          const newPaymentArray = [...response.payments, newPayment];
          const newResponse = { ...response, payments: newPaymentArray };

          const updatedPaymentDetails = [...paymentDetails, newPayment];

          dispatch(updatePaymentDetails(updatedPaymentDetails));
          dispatch(updateBookingListData(newResponse));

          dispatch(updateDisplayCheckOutDrawerAction(false));
          dispatch(updateShowAttachToPartyDrawer(false));

          message.destroy();
          message.success("Party updated");

          dispatch(updateAttachPartyString(""));
          dispatch(updateAttachPartyValue(""));
        } else message.error("Attach to Party failed");
      }
    }

    setLoading(false);
  };

  const handleDeletePayment = async (
    id,
    isBookingDetailsDrawer,
    displayMessage,
    isPosComponent,
    currentPosInvoice
  ) => {
    message.destroy();
    setLoading(true);

    try {
      if (!id) {
        message.info("Something went wrong");
        setLoading(false);
        return;
      }

      const paymentPayload = {
        hotelId: hotelDetails?.id,
        id: id,
      };

      const deletedPaymentResponse = await dispatch(
        deletePayment(paymentPayload)
      );

      if (!deletedPaymentResponse?.payload?.data) {
        message.info("Something went wrong");
        setLoading(false);
        return;
      }

      if (isBookingDetailsDrawer) {
        // Filter out the deleted payment from the response
        const newPaymentArray = bookingResponse?.payments?.filter(
          (Obj) => Obj?.id !== paymentPayload?.id
        );

        // Update the payment details in the local state
        const updatedPaymentDetails = paymentDetails?.filter(
          (Obj) => Obj?.id !== paymentPayload?.id
        );

        const newResponse = { ...bookingResponse, payments: newPaymentArray };

        dispatch(updatePaymentDetails(updatedPaymentDetails));
        dispatch(updateBookingListData(newResponse));
      }

      if (isPosComponent) {
      }

      message.destroy();
      message.success(displayMessage);

      setLoading(false);
      dispatch(
        updateDisplayDeletePartyModal({ display: false, partyName: "" })
      );

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setLoading(false);
      message.error("An error occurred while deleting the attached party");
    }
  };


  /**
   * Updates invoice prices and discount info, including discount comment.
   * @param {Object} discountInfo - { type, value, comment }
   * @param {Function} setInitialRender
   */
  const updateInvoicePricesAsDiscount = async (
    discountType,
    discountValue,
    setInitialRender,
    discountComment
  ) => {
    
    setLoading(true);

    let roomInvoice = Array.isArray(invoiceDetails)
      ? invoiceDetails?.find((Obj) => Obj?.invoiceType === "roomBill")
      : null;
    const bookingDetails = updateBookingStore?.bookingDetails;
    const { nightsCount } = updateBookingStore;
    const rooms = roomsStore.data;
    const detailedRoomInthisBooking = rooms?.filter((r) => bookingDetails?.rooms.includes(r.id));

    let detailedPriceBreakup = roomInvoice && roomInvoice.detailedPriceBreakup
      ? JSON.parse(JSON.stringify(roomInvoice?.detailedPriceBreakup))
      : generateDetailedPriceBreakupForEditBookings({
          detailedRoomInthisBooking,
          roomTypes,
          noOfNights: nightsCount,
          priceBreakup: roomInvoice?.priceBreakup,
          complimentaryRoomIds: bookingDetails?.markedComplementaryRoomIdArrayInBooking,
        });
    let totalPrice = 0;
    for (let i in detailedPriceBreakup) {
      totalPrice += detailedPriceBreakup[i].rate * detailedPriceBreakup[i].count;
    }

    const discountInfo = {
      type: discountType,
      value: discountValue,
      comment: discountComment,
    };
    const taxIncludedInPriceLocalState = updateBookingStore.invoiceDetails?.find(invoiceDetail=>invoiceDetail?.invoiceType === 'roomBill')?.taxIncludedInPrice;
    updateDiscountedRate({ detailedPriceBreakup, discountInfo, totalPrice,
      taxIncludedInPriceLocalState, taxes:taxResponse
     });

    if (
      Boolean(roomInvoice) &&
      Array.isArray(detailedPriceBreakup) &&
      detailedPriceBreakup?.length > 0 &&
      roomTypes?.length
    ) {
      let taxObjectArray = roomInvoice?.taxObjects;

      let oldAddOnsArray = roomInvoice?.priceBreakup?.filter(
        (Obj) => Obj?.type === "Addons"
      );

      oldAddOnsArray = Array.isArray(oldAddOnsArray)
        ? oldAddOnsArray?.[0]?.addOns
        : [];

      const result = bookingPriceCalculation(
        detailedPriceBreakup,
        taxResponse
      );

      let oldAddOnsCalcResult = bookingDetailsAddOnsCalculationV2(
        oldAddOnsArray,
        taxObjectArray
      );

      let newPriceBreakup = buildPriceBreakup(detailedPriceBreakup);

      Array.isArray(oldAddOnsArray) &&
      oldAddOnsArray?.length &&
      newPriceBreakup?.push({
        addOns: oldAddOnsArray,
        baseRate: 0,
        rate: 0,
        count: 1,
        type: "Addons",
      });

      const newInvoiceDetails = JSON.parse(JSON.stringify(roomInvoice));

      // Removing existing Room Tax but keeping addOn Tax as it is
      newInvoiceDetails.totalTax =
        oldAddOnsCalcResult?.taxRate + result?.totalRoomTax;

      newInvoiceDetails.subTotal = result?.subTotal;
      newInvoiceDetails.total = result?.total + oldAddOnsCalcResult?.totalRate;


      newInvoiceDetails.discountInfo = discountInfo;
      newInvoiceDetails.discount = result?.discount;

      newInvoiceDetails.priceBreakup = newPriceBreakup;
      newInvoiceDetails.detailedPriceBreakup = detailedPriceBreakup;
      // Ensure discountInfo (with comment) is set
      newInvoiceDetails.discountInfo = discountInfo;

      const payload = {
        hotelId: newInvoiceDetails?.hotelId,
        id: newInvoiceDetails?.id,
        body: newInvoiceDetails,
      };


      const data = await updateinvoice(payload);


      if (Boolean(data?.id)) {
        const updatedData = invoiceDetails?.map((item) =>
          Boolean(item.id === data?.id) ? data : item
        );

        message.success("Discount Applied");
        await dispatch(updateInvoiceDetails(updatedData));
        Boolean(setInitialRender) && setInitialRender(true);
        dispatch(updateShowApplyDiscountDrawer());
      } else message.info("Something Went Wrong 1");
    } else message.info("Something Went Wrong 2");

    setLoading(false);
  };

  // This below function are common to Create Booking (Mobile and Desktop)  and in Booking details (Mobile and Desktop)
  const handleRoomSelectionModalApplyButton = ({
    saveTempSelectedRoomWTypeAndNum,
    updateVisibleRoomNumberModal,
  }) => {
    dispatch(saveTempSelectedRoomWTypeAndNum());
    dispatch(updateVisibleRoomNumberModal(false));
  };

  function constructRoomObjectToStoreInSelectedRoomsAndRoomTypeList(roomDetails, roomTypeName, roomPriceStructure) {
    const {roomTypes} = hotelDetails;
    const roomTypeObj = roomTypes.find(rt=>rt.name === roomTypeName);
    const roomPriceStructureOfRelevantRoomType = roomPriceStructure?.find(rps=> rps.name === roomTypeName);
    const price = roomPriceStructureOfRelevantRoomType && roomPriceStructureOfRelevantRoomType.rate ? roomPriceStructureOfRelevantRoomType.rate : 0;
    const defaultOccupancy = Number(roomTypeObj?.defaultOccupancy || 2);
    return {
      id: roomDetails.id,
      name:roomDetails.name,
      roomTypeId: roomDetails.roomTypeId,
      roomTypeName: roomDetails.type,
      rate: Number(price),
      occupancy: defaultOccupancy,
      adults: defaultOccupancy,
      children: 0,
      taxIds: roomTypeObj.taxIds
    };
  }

  const handleSelectedRoomChangeInRoomSelectionModal = (
    selectedStatus,
    roomType,
    roomNum,
    roomArray,
    tempSelectedRoomWTypeAndNum,
    updateTempSelectedRoomWTypeAndNum,
    roomPriceStructure
  ) => {
    if (selectedStatus) {
      let updatedRoomListOfRoomType = tempSelectedRoomWTypeAndNum[roomType]?.filter(
        (item) => item.name !== roomNum
      );

      dispatch(
        updateTempSelectedRoomWTypeAndNum({
          ...tempSelectedRoomWTypeAndNum,
          [roomType]: updatedRoomListOfRoomType,
        })
      );
    } else {
      const roomObject = constructRoomObjectToStoreInSelectedRoomsAndRoomTypeList(roomArray, roomType, roomPriceStructure);
      if (Boolean(tempSelectedRoomWTypeAndNum[roomType])) {
        let selectedRoomArray = tempSelectedRoomWTypeAndNum[roomType];
        dispatch(
          updateTempSelectedRoomWTypeAndNum({
            ...tempSelectedRoomWTypeAndNum,
            [roomType]: [...selectedRoomArray, roomObject],
          })
        );
      } else {
        dispatch(
          updateTempSelectedRoomWTypeAndNum({
            ...tempSelectedRoomWTypeAndNum,
            [roomType]: [roomObject],
          })
        );
      }
    }
  };

  const handleGuestChangeInRoomType = ({
    roomTypeObj,
    roomTypeName,
    selectedRoomWTypeAndNum,
    adults,
    children,
    updateSelectedRoomNumbersListWithRoomType
  }
  ) => {
    const roomTypeAndNumMap = JSON.parse(JSON.stringify(selectedRoomWTypeAndNum));
    const maxGuestsAllowed = Number(roomTypeObj?.maxGuestAllowed || roomTypeObj?.guestsAllowed || 4);
    const defaultOccupancy = Number(roomTypeObj?.defaultOccupancy || 2);
    const rooms = roomTypeAndNumMap[roomTypeName];
    
    if (!rooms || rooms.length === 0) return;
    
    // Validate total capacity
    const totalGuests = adults + children;
    const totalCapacity = rooms.length * maxGuestsAllowed;
    
    if (totalGuests > totalCapacity) {
      message.warning(`Total guests (${totalGuests}) exceed room capacity (${totalCapacity})`);
      return;
    }
    
    if (adults < rooms.length) {
      message.warning(`At least one adult required per room`);
      return;
    }
    
    // Distribute guests across rooms
    let remainingAdults = adults;
    let remainingChildren = children;
    let remainingGuestsCount = totalGuests;
    
    // Step 1: First ensure at least 1 adult per room
    for (const i in rooms) {
      rooms[i].adults = 1;
      rooms[i].children = 0;
      rooms[i].occupancy = 1;
      remainingAdults--;
      remainingGuestsCount--;
    }
    
    // Step 2: Fill up to defaultOccupancy (prioritizing adults)
    for (const i in rooms) {
      const room = rooms[i];
      if (defaultOccupancy - room.occupancy <= remainingGuestsCount) {
        const spotsToFill = defaultOccupancy - room.occupancy;
        const adultsToAdd = Math.min(spotsToFill, remainingAdults);
        const childrenToAdd = spotsToFill - adultsToAdd;
        
        room.adults += adultsToAdd;
        room.children += childrenToAdd;
        room.occupancy = defaultOccupancy;
        
        remainingAdults -= adultsToAdd;
        remainingChildren -= childrenToAdd;
        remainingGuestsCount -= spotsToFill;
      } else if (defaultOccupancy - room.occupancy > 0 && remainingGuestsCount > 0) {
        const spotsToFill = remainingGuestsCount;
        const adultsToAdd = Math.min(spotsToFill, remainingAdults);
        const childrenToAdd = Math.min(spotsToFill - adultsToAdd, remainingChildren);
        
        room.adults += adultsToAdd;
        room.children += childrenToAdd;
        room.occupancy += adultsToAdd + childrenToAdd;
        
        remainingAdults -= adultsToAdd;
        remainingChildren -= childrenToAdd;
        remainingGuestsCount = 0;
      }
    }
    
    // Step 3: Fill up to maxGuestsAllowed if needed
    for (const i in rooms) {
      const room = rooms[i];
      if (maxGuestsAllowed - room.occupancy <= remainingGuestsCount) {
        const spotsToFill = maxGuestsAllowed - room.occupancy;
        const adultsToAdd = Math.min(spotsToFill, remainingAdults);
        const childrenToAdd = Math.min(spotsToFill - adultsToAdd, remainingChildren);
        
        room.adults += adultsToAdd;
        room.children += childrenToAdd;
        room.occupancy = maxGuestsAllowed;
        
        remainingAdults -= adultsToAdd;
        remainingChildren -= childrenToAdd;
        remainingGuestsCount -= (adultsToAdd + childrenToAdd);
      } else if (maxGuestsAllowed - room.occupancy > 0 && remainingGuestsCount > 0) {
        const spotsToFill = Math.min(maxGuestsAllowed - room.occupancy, remainingGuestsCount);
        const adultsToAdd = Math.min(spotsToFill, remainingAdults);
        const childrenToAdd = Math.min(spotsToFill - adultsToAdd, remainingChildren);
        
        room.adults += adultsToAdd;
        room.children += childrenToAdd;
        room.occupancy += adultsToAdd + childrenToAdd;
        
        remainingAdults -= adultsToAdd;
        remainingChildren -= childrenToAdd;
        remainingGuestsCount -= (adultsToAdd + childrenToAdd);
      }
    }
    
    
    
    dispatch(updateSelectedRoomNumbersListWithRoomType(roomTypeAndNumMap));
  };
  const handleRoomCountOfRoomTypeChange = ({
    count,
    roomTypeObj,
    selectedRoomWTypeAndNum,
    roomPriceStructure,
    updateSelectedRoomNumbersListWithRoomType,
    allAvailableRoomsOfRoomType
  })=>{
    const currentRoomPriceStructure = roomPriceStructure.find(r=> r.name === roomTypeObj.name);
    let price = 0;
    if(currentRoomPriceStructure && currentRoomPriceStructure.rate){
      price = currentRoomPriceStructure.rate;
    }

    const selectedRoomsList = selectedRoomWTypeAndNum[roomTypeObj?.name]? JSON.parse(JSON.stringify(selectedRoomWTypeAndNum[roomTypeObj?.name])) : [];
    const selectedRoomIdsList = selectedRoomsList?.map(r=>r.id);
    const currentlyAvailableRooms = allAvailableRoomsOfRoomType.filter(r=>!selectedRoomIdsList.includes(r.id));
    const alreadySelectedRoomsArrayLength = (selectedRoomWTypeAndNum[roomTypeObj?.name] ? selectedRoomWTypeAndNum[roomTypeObj?.name].length : 0);
    if(alreadySelectedRoomsArrayLength > count){
      for(let i = alreadySelectedRoomsArrayLength; i > count; i--){
        selectedRoomsList.pop();
      }
    } else if (alreadySelectedRoomsArrayLength < count){
      if(currentlyAvailableRooms.length > 0){
        for(let i = alreadySelectedRoomsArrayLength; i < count; i++){
          const roomDetails = currentlyAvailableRooms[i - alreadySelectedRoomsArrayLength];
          const defaultOccupancy = Number(roomTypeObj?.defaultOccupancy || 2);
          selectedRoomsList.push({
            id: roomDetails.id, 
            name:roomDetails.name, 
            roomTypeId: roomDetails.roomTypeId,
            roomTypeName: roomDetails.type,
            rate: Number(price),
            occupancy: defaultOccupancy,
            adults: defaultOccupancy,
            children: 0,
            taxIds: roomTypeObj.taxIds
          });
        }
      }
    }
    let updatedSelectedRoomsTypeAndNum = JSON.parse(JSON.stringify(selectedRoomWTypeAndNum));
    if(selectedRoomsList.length > 0){
      updatedSelectedRoomsTypeAndNum[String(roomTypeObj.name)] = selectedRoomsList;
    }
    if(updatedSelectedRoomsTypeAndNum[roomTypeObj?.name] && selectedRoomsList.length === 0){
      delete updatedSelectedRoomsTypeAndNum[roomTypeObj?.name];
    }
    dispatch(updateSelectedRoomNumbersListWithRoomType(updatedSelectedRoomsTypeAndNum));
  };
  const handleRoomCountOfRoomTypeChangeInCreateBooking = ({
    count,
    roomTypeObj
  })=>{
    const allAvailableRoomsOfRoomType = roomTypeObj?.rooms ? roomTypeObj?.rooms : [];
    let {detailedPriceBreakup, selectedRoomWTypeAndNum, roomPriceStructure} = createBookingStore;
    const {updateSelectedRoomNumbersListWithRoomType} = createBookingSlice.actions;
    // get list of selected rooms and with that construct list of currentlyAvailable rooms
    // check if count mentioned is greater or less than count of currently selected rooms
    // if count is greater, add rooms from currently available rooms to list of selected rooms
    // save selectedRoomWTypeAndNum
    handleRoomCountOfRoomTypeChange({
      count,
      roomTypeObj,
      selectedRoomWTypeAndNum,
      roomPriceStructure,
      updateSelectedRoomNumbersListWithRoomType,
      allAvailableRoomsOfRoomType
    })
  };

  const handleRoomCountOfRoomTypeChangeInUpdateBooking = ({
    count,
    roomTypeObj
  })=>{
    
    const allAvailableRoomsOfRoomType = roomTypeObj?.rooms ? roomTypeObj?.rooms : [];
    
    let {detailedPriceBreakup, selectedRoomWTypeAndNum, roomPriceStructure} = updateBookingStore;
    const {updateSelectedRoomNumberForModify} = updateBookingSlice.actions;
    
    
    // get list of selected rooms and with that construct list of currentlyAvailable rooms
    // check if count mentioned is greater or less than count of currently selected rooms
    // if count is greater, add rooms from currently available rooms to list of selected rooms
    // save selectedRoomWTypeAndNum
    handleRoomCountOfRoomTypeChange({
      count,
      roomTypeObj,
      selectedRoomWTypeAndNum,
      roomPriceStructure,
      updateSelectedRoomNumbersListWithRoomType:updateSelectedRoomNumberForModify,
      allAvailableRoomsOfRoomType
    });
    
  }

  

  const handleRoomSelectionModalApplyButtonUpdateBooking = () => {
    const { 
      saveTempSelectedRoomWTypeAndNum,
      updateShowRoomNumberModal
    } = updateBookingSlice.actions;
    handleRoomSelectionModalApplyButton({
      updateVisibleRoomNumberModal:updateShowRoomNumberModal,
      saveTempSelectedRoomWTypeAndNum
    });
    // dispatch(updateShowRoomNumberModal());
  }

  const handleRoomSelectionModalApplyButtonCreateBooking = () => {
    const { 
      saveTempSelectedRoomWTypeAndNum,
      updateVisibleRoomNumberModal,
    } = createBookingSlice.actions;
    handleRoomSelectionModalApplyButton({
      saveTempSelectedRoomWTypeAndNum,
      updateVisibleRoomNumberModal,
    });
  }
  const handleGuestChangeInRoomTypeWithComplimentaryRoomsLogic = ()=>{

  }  

  const handleGuestChangeInRoomTypeCreateBooking = ({
    roomTypeObj,
    roomTypeName,
    adults,
    children
  })=>{
    const {
      selectedRoomWTypeAndNum
    } = createBookingStore;
    const {
      updateSelectedRoomNumbersListWithRoomType
    } = createBookingSlice.actions;
    handleGuestChangeInRoomType({
      roomTypeObj,
      roomTypeName,
      selectedRoomWTypeAndNum,
      adults,
      children,
      updateSelectedRoomNumbersListWithRoomType
    });
  }

  const handleGuestChangeInRoomTypeUpdateBooking = ({
    roomTypeObj,
    roomTypeName,
    adults,
    children
  })=>{
    /*
    on update of this, update selectedRoomWTypeAndNum
    */
    
    const { occupancyPlanRate } = loginStore;
    const {
      selectedRoomWTypeAndNum,
    } = updateBookingStore;
    const {
      updateSelectedRoomNumberForModify,
    } = updateBookingSlice.actions;
    
    
    handleGuestChangeInRoomType({
      roomTypeObj,
      roomTypeName,
      selectedRoomWTypeAndNum,
      adults,
      children,
      updateSelectedRoomNumbersListWithRoomType: updateSelectedRoomNumberForModify
    });
    
  }

  useEffect(()=>{
    const complimentaryRoomIdsList = JSON.parse(JSON.stringify(createBookingStore.markedComplementaryRoomIdArrayInBooking));
    const selectedRoomTypesWithRoomsAndOccupancyList = createBookingStore.selectedRoomWTypeAndNum;
    const occupancyPlanRate = loginStore.occupancyPlanRate;
    const discountInfo = createBookingStore.discountInfo;
    const taxIncludedInPriceLocalState = createBookingStore.taxIncludedInPriceLocalState;
    const nightsCount= createBookingStore.nightsCount;
    const mealPlan = createBookingStore.mealPlan;
    const roomPriceStructure = createBookingStore.roomPriceStructure;
    const taxes = taxResponse;
    const updateDetailedPriceBreakupCreateBooking = createBookingSlice.actions.updateDetailedPriceBreakup;
    updateDeatiledPriceBreakup({
      selectedRoomTypesWithRoomsAndOccupancyList,
      occupancyPlanRate, 
      mealPlan, 
      complimentaryRoomIdsList, 
      taxIncludedInPriceLocalState, 
      taxes,
      nightsCount,
      updateDetailedPriceBreakup:updateDetailedPriceBreakupCreateBooking,
      roomPriceStructure,
      discountInfo
    })
  },[
    createBookingStore.markedComplementaryRoomIdArrayInBooking,
    createBookingStore.selectedRoomWTypeAndNum,
    loginStore.occupancyPlanRate,
    createBookingStore.discountInfo,
    createBookingStore.taxIncludedInPriceLocalState,
    createBookingStore.nightsCount, 
    createBookingStore.mealPlan,
    taxResponse,
    createBookingStore.roomPriceStructure
  ]);

  const updatedDetialedPriceBreakupForUpdateBooking = (discountInfo)=>{
    let complimentaryRoomIdsList = [];
    if(updateBookingStore && updateBookingStore?.bookingDetails && updateBookingStore?.bookingDetails?.markedComplementaryRoomIdArrayInBooking){
      complimentaryRoomIdsList = JSON.parse(JSON.stringify(updateBookingStore?.bookingDetails?.markedComplementaryRoomIdArrayInBooking));
    }
    const selectedRoomTypesWithRoomsAndOccupancyList = updateBookingStore.selectedRoomWTypeAndNum;
    const occupancyPlanRate = loginStore.occupancyPlanRate;
    const taxIncludedInPriceLocalState = updateBookingStore.taxIncludedInPriceLocalState;
    const nightsCount= updateBookingStore.nightsCount;
    const mealPlan = updateBookingStore.mealPlan;
    const roomPriceStructure = updateBookingStore.roomPriceStructure;
    const taxes = taxResponse;
    const updateDetailedPriceBreakupUpdateBooking = updateBookingSlice.actions.updateDetailedPriceBreakup;
    return updateDeatiledPriceBreakup({
      selectedRoomTypesWithRoomsAndOccupancyList,
      occupancyPlanRate, 
      mealPlan, 
      complimentaryRoomIdsList, 
      taxIncludedInPriceLocalState, 
      taxes,
      nightsCount,
      updateDetailedPriceBreakup:updateDetailedPriceBreakupUpdateBooking,
      roomPriceStructure,
      discountInfo
    })
  }
  
  useEffect(()=>{
    updatedDetialedPriceBreakupForUpdateBooking(updateBookingStore.discountInfo)
    
  },[
    updateBookingStore?.bookingDetails?.markedComplementaryRoomIdArrayInBooking,//to be set
    updateBookingStore.selectedRoomWTypeAndNum, //recently set and checked
    loginStore.occupancyPlanRate,//should be the same as exists outside create booking store, still change depends on price change operation
    updateBookingStore.discountInfo,// vale has been set now
    updateBookingStore.taxIncludedInPriceLocalState,//checked
    updateBookingStore.nightsCount, //checked
    updateBookingStore.mealPlan, // checked
    taxResponse, //set outside booking, does not change in process, should not bother
  ]);

  const updateDeatiledPriceBreakup = ({
    selectedRoomTypesWithRoomsAndOccupancyList,
    occupancyPlanRate, 
    mealPlan, 
    complimentaryRoomIdsList, 
    taxIncludedInPriceLocalState, 
    taxes,
    nightsCount,
    updateDetailedPriceBreakup,
    roomPriceStructure,
    discountInfo
  })=>{
    let totalPrice = 0.0;

    const detailedPriceBreakup = [];
    for(let roomTypeName in selectedRoomTypesWithRoomsAndOccupancyList){
      const selectedRoomsOfRoomType = selectedRoomTypesWithRoomsAndOccupancyList[roomTypeName];
      for(let i in selectedRoomsOfRoomType){
        const room = selectedRoomsOfRoomType[i];
        const price = findRate({room, occupancyPlanRate, mealPlan, complimentaryRoomIdsList, taxIncludedInPriceLocalState, taxes, roomPriceStructure})
        const priceBreakupDeatil = {
          name: roomTypeName,
          id: room.id,
          roomNumber: room.name,
          count: nightsCount,
          occupancy: room.occupancy,
          adults: room.adults || 0,
          children: room.children || 0,
          rate: price,
          baseRate: findBaseRate({roomPriceStructure, roomTypeName, price}),
          taxIds: room.taxIds,
          extraAdultRate: +roomPriceStructure.find(r => r.name === roomTypeName)?.extraGuestRate || 0,
          extraChildRate: +roomPriceStructure.find(r => r.name === roomTypeName)?.extraChildRate || 0,
          singleGuestReductionRate: +roomPriceStructure.find(r => r.name === roomTypeName)?.singleGuestPriceReduction || 0
       };
        detailedPriceBreakup.push(priceBreakupDeatil)
        totalPrice += price * priceBreakupDeatil.count;
      }
    }
    updateDiscountedRate({detailedPriceBreakup, discountInfo, totalPrice, 
      taxIncludedInPriceLocalState, taxes})
    dispatch(updateDetailedPriceBreakup(detailedPriceBreakup));
    return detailedPriceBreakup;
  }

  useEffect(()=>{
    const updateAdultsReducer = createBookingSlice.actions.updateAdults;
    const updateChildrenReducer = createBookingSlice.actions.updateChildren;
    updateAdults({
      selectedRoomTypesWithRoomsAndOccupancyList: createBookingStore.selectedRoomWTypeAndNum,
      updateAdultsReducer,
      updateChildrenReducer
    });
  },[createBookingStore.selectedRoomWTypeAndNum]);

  const updateAdults = ({
    selectedRoomTypesWithRoomsAndOccupancyList,
    updateAdultsReducer,
    updateChildrenReducer
  }) =>{
    let totalAdults = 0;
    let totalChildren = 0;
    
    for(const roomTypeName in selectedRoomTypesWithRoomsAndOccupancyList){
      const selectedRoomsOfRoomType = selectedRoomTypesWithRoomsAndOccupancyList[roomTypeName];
      for(let i in selectedRoomsOfRoomType){
        const room = selectedRoomsOfRoomType[i];
        
        // If adults/children are defined, use them
        if(room && (room.adults !== undefined || room.children !== undefined)){
          totalAdults += Number(room.adults || 0);
          totalChildren += Number(room.children || 0);
        } 
        // Fallback for backward compatibility - if only occupancy exists
        else if(room && room.occupancy){
          totalAdults += Number(room.occupancy);
        }
      }
    }
    dispatch(updateAdultsReducer(totalAdults));
    if(updateChildrenReducer) {
      dispatch(updateChildrenReducer(totalChildren));
    }
  }

  useEffect(()=>{
    const updateAdultsReducer = updateBookingSlice.actions.updateAdults;
    const updateChildrenReducer = updateBookingSlice.actions.updateChildren;
    updateAdults({
      selectedRoomTypesWithRoomsAndOccupancyList: updateBookingStore.selectedRoomWTypeAndNum,
      updateAdultsReducer,
      updateChildrenReducer
    });
  },[updateBookingStore.selectedRoomWTypeAndNum]);
  

  const findRate = ({room, occupancyPlanRate, mealPlan, complimentaryRoomIdsList, taxIncludedInPriceLocalState, taxes, roomPriceStructure}) =>{
    if(complimentaryRoomIdsList.includes(room.id)){
      return 0;
    }

    const roomPriceInfo = roomPriceStructure?.find(r => r.name === room.roomTypeName || r.name === room.name);
    const roomType = roomTypes?.find(rt => rt.name === room.roomTypeName || rt.name === room.name);
    const defaultOccupancy = roomType?.defaultOccupancy || 2;

    // Calculate total occupancy (adults + children)
    const adultsInRoom = room.adults || 0;
    const childrenInRoom = room.children || 0;
    const totalOccupancy = adultsInRoom + childrenInRoom;
    
    // Get base rate based on total occupancy or default if within default occupancy
    let occupancyRate;
    if (totalOccupancy <= defaultOccupancy) {
      // No extra charges if within default occupancy
      occupancyRate = occupancyPlanRate?.[room?.roomTypeId]?.[mealPlan]?.[totalOccupancy] || 0;
    } else {
      // ALWAYS use manual calculation when children are present
      // This bypasses the incorrect pre-calculated rates from backend
      if (childrenInRoom > 0) {
        const defaultRate = occupancyPlanRate?.[room?.roomTypeId]?.[mealPlan]?.[defaultOccupancy] || 0;
        const extraGuests = totalOccupancy - defaultOccupancy;
        const extraAdultRate = roomPriceInfo?.extraGuestRate || 0;
        const extraChildRate = roomPriceInfo?.extraChildRate || 0;
        
        // Apply different rates for extra adults vs extra children
        const extraAdults = Math.max(0, adultsInRoom - defaultOccupancy);
        const extraChildren = extraGuests - extraAdults;
        occupancyRate = defaultRate + (extraAdults * extraAdultRate) + (extraChildren * extraChildRate);
      } else {
        // Only use pre-calculated rate for all-adult bookings
        occupancyRate = occupancyPlanRate?.[room?.roomTypeId]?.[mealPlan]?.[totalOccupancy] || 0;
      }
    }

    if(taxIncludedInPriceLocalState){
      let taxPercentage = findTaxPercentage({amount: occupancyRate, taxes, taxIds: room.taxIds});
      return occupancyRate / (1 + (taxPercentage / 100));
    }
    return occupancyRate;
  }
  const findBaseRate = ({roomPriceStructure, roomTypeName, price}) =>{
    const roomPriceForRoomType = roomPriceStructure.find(r => r.name === roomTypeName);
    if(roomPriceForRoomType && roomPriceForRoomType.rate){
      return roomPriceForRoomType.rate;
    }
    return 0;
  }
  const updateDiscountedRate = ({detailedPriceBreakup, discountInfo, totalPrice
    , taxIncludedInPriceLocalState, taxes}) =>{
    if(!detailedPriceBreakup || detailedPriceBreakup.length === 0){
      return;
    }
    if(!discountInfo || !discountInfo.type || !discountInfo.value){
      discountInfo = {type: 'percentage', value: 0}
    }
    const totalDiscount = discountInfo.type === 'percentage' ? (discountInfo.value / 100) * totalPrice : discountInfo.value;
    for(let i in detailedPriceBreakup){
      const discountForRoom = findDiscountForRoom({dpb: detailedPriceBreakup[i], totalPrice, totalDiscount, 
        discountInfo, taxIncludedInPriceLocalState, taxes
      });
      detailedPriceBreakup[i].discountedRate = Number(detailedPriceBreakup[i].rate) - discountForRoom / Number(detailedPriceBreakup[i].count) || 1;
    }
  }
  const findDiscountForRoom = ({dpb, totalPrice, totalDiscount, 
    discountInfo, taxIncludedInPriceLocalState, taxes}) => {
    const priceOfRoomForAllNights = Number(dpb.count) * Number(dpb.rate);
    if(priceOfRoomForAllNights == 0){
      return 0;
    }
    let discountForRoom = priceOfRoomForAllNights / Number(totalPrice) * Number(totalDiscount);
    if(discountInfo?.type === 'flat' && taxIncludedInPriceLocalState){
      const taxPercentage = findTaxPercentage({amount: dpb.rate,  taxes, taxIds: dpb.taxIds});
      discountForRoom = discountForRoom / (1 + (taxPercentage / 100));
    }
    return discountForRoom;
  }
  const calculateDefaultOccupancy = ({roomDetails})=>{
    return Boolean(roomDetails?.defaultOccupancy)
    ? roomDetails?.defaultOccupancy
    : 2;
  }
  const checkOutConditional = ({})=>{
    const isCheckoutDrawerEnabled = !loginStore?.hotelDetails?.allowEditingAfterCheckout;
    if(!isCheckoutDrawerEnabled){
      handleCheckOut();
    } else{
      const {paymentDetails, invoiceDetails} = updateBookingStore;
      const localPayemnts = paymentDetails
          ?.map((item) => item.amount)
          ?.filter((Obj) => Boolean(Obj))
          ?.filter((Obj) => Obj > 0)
          ?.reduce((total, num) => total + num, 0);

      const localRefund = paymentDetails
          ?.map((item) => item.amount)
          ?.filter((Obj) => Boolean(Obj))
          ?.filter((Obj) => Obj < 0)
          ?.reduce((total, num) => total + -num, 0);
      let totalAmount = invoiceDetails
          ?.map((item) => item.total)
          ?.filter((Obj) => Boolean(Obj))
          ?.reduce((total, num) => total + num, 0);
      let balanceDue = totalAmount - localPayemnts + localRefund;
      if(balanceDue > 0.01) {
        dispatch(updateDisplayCheckOutDrawerAction(true));
      } else{
        handleCheckOut();
      }
    }
  }

  return {
    handleCheckIn,
    handleCheckOut,
    checkOutConditional,
    handleUndoCheckIn,
    handleFolio,
    handleGrc,
    handleConfirmBooking,
    refund,
    handleAttachToParty,
    updateInvoicePricesAsDiscount,
    handleDeletePayment,
    handleBookingToBeCanceld,
    handleBookingToBeMarkedNoShow,
    handleUndoCheckOut,
    handleBookingToBeDeleted,
    handleSelectedRoomChangeInRoomSelectionModal,
    handleGuestChangeInRoomType,
    handleRoomSelectionModalApplyButtonUpdateBooking,
    handleRoomSelectionModalApplyButtonCreateBooking,
    handleGuestChangeInRoomTypeCreateBooking,
    handleGuestChangeInRoomTypeUpdateBooking,
    handleRoomCountOfRoomTypeChangeInCreateBooking,
    handleRoomCountOfRoomTypeChangeInUpdateBooking,
    calculateDefaultOccupancy,
  };
};

export default useAllBookingFunction;
